export function buildReplySubject(subject: string): string {
    const safeSubject = subject || "";
    return /^re:/i.test(safeSubject) ? safeSubject : "Re: " + safeSubject;
}

export function buildForwardSubject(subject: string): string {
    const safeSubject = subject || "";
    return /^fwd:/i.test(safeSubject) ? safeSubject : "Fwd: " + safeSubject;
}

export function htmlToPlainText(html: string): string {
    return html
        .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(p|div|tr)>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .trim();
}

function getBodyText(message: any): string {
    return message?.body?.text || htmlToPlainText(message?.body?.html || "");
}

export function buildQuotedReplyBody(message: any): string {
    const fromText = message?.from?.text || "";
    const date = message?.date || "";
    const quotedLines = getBodyText(message)
        .split("\n")
        .map((line) => "> " + line)
        .join("\n");
    return "\n\nOn " + (date ? date + ", " : "") + fromText + " wrote:\n" + quotedLines;
}

export function buildForwardedBody(message: any): string {
    const fromText = message?.from?.text || "";
    const toText = message?.to?.text || "";
    const date = message?.date || "";
    const subject = message?.subject || "";
    return "\n\n---------- Forwarded message ----------\n"
        + "From: " + fromText + "\n"
        + (date ? "Date: " + date + "\n" : "")
        + "Subject: " + subject + "\n"
        + "To: " + toText + "\n\n"
        + getBodyText(message);
}
